// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> weidner-apartment-homes-vantage -> the-club-at-heritage
// Generated: 2026-11-02T15:49:51.311Z
// Counts: 0 design, 21 content, 20 slot group, 1 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "footer.social_label": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p><span style=\"font-size: 11pt;\">Pit Bull &amp; Pit Bull Mixes&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Pit Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Staffordshire Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Wolf Hybrids&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Doberman Pinscher&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Saint Bernard&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Bulldog&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Staffordshire Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Rottweiler&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">German Shepherd&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Chow Chow&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Great Dane&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Akita&nbsp;</span></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy the best of both worlds at The Club at Heritage. In-home amenities like stainless-steel appliances, in-unit washers and dryers, and walk-in closets make daily life effortless. Step out and discover a newly remodeled fitness center, a sparkling pool and spa, and inviting community spaces where neighbors become friends. Welcome to comfort, convenience, and connection in Sartell, MN.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Connect with our friendly leasing team at The Club at Heritage in Sartell, MN. Whether you have questions about floor plans, want to tour, or seek more details, we're here to help you feel at home. Reach out and let's get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your ideal layout among our studio, one-, two-, and three-bedroom apartments for rent in Sartell, MN. Each home is thoughtfully designed to offer the flexibility to work from home, unwind in style, and stay organized with walk-in and walk-through closets. Enjoy the convenience of in-home laundry, spacious 10-foot ceilings, and private patios or balconies in select homes. Modern kitchens with stainless-steel appliances and open-concept living areas make daily routines easier and more enjoyable. Your new home pairs comfort with practical perks, all in a fresh, vibrant setting.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into our gallery and imagine yourself at home at The Club at Heritage in Sartell, MN. Take in the details - bright kitchens, spacious living rooms, relaxing patios, and lively amenities. Scroll through images of real apartments and welcoming social spaces, each with thoughtful design that's ready for your personal style. Picture yourself making memories here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Club at Heritage, south Sartell's appealing blend of recreation, convenience, and community is at your doorstep. Stroll to Coborn's grocery for fresh finds or recharge in Meadow Lake Park. The Sartell Community Center is minutes away for fitness and events, while easy access to Highway 15 connects you to greater St. Cloud. Local parks, shopping, and dining make errands fun and social time effortless. Here, every day brings new places to explore and opportunities to connect.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>South Sartell is a vibrant, welcoming place to call home. Pick up groceries at Coborn's, hike or picnic at Meadow Lake Park, or enjoy a day at the Sartell Community Center. Quick access to Highway 15 puts St. Cloud's major employers and attractions within easy reach. Whether you're catching up with friends at a local restaurant or exploring nearby trails, you're always minutes from what matters most.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for apartments for rent in Sartell, MN? At The Club at Heritage, you'll find brand-new layouts, in-home laundry, and pet-friendly spaces close to everything you love about the city. Enjoy the freedom to choose from studio, one-, two-, and three-bedroom floor plans, each filled with sunlight and modern touches. Your routines feel effortless - whether you're working out in the fitness center, letting your pup run at the dog park, or unwinding in the outdoor spa. Connect with your neighbors, relax in fresh community spaces, and love where you live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to take a closer look at The Club at Heritage in Sartell, MN? Pick the tour style that's right for you - from in-person guided tours to convenient virtual walkthroughs from wherever you are. Our team will help you find the space that fits your needs. Touring is easy, flexible, and tailored to your comfort level.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture your new life at The Club at Heritage without leaving home. Our virtual tour lets you preview layouts, room flow, and the community atmosphere, making it easy to see if Sartell's newest apartment homes are a fit for you. Whether you're planning your next move from across town or across the country, get a sense of style, comfort, and connection - all online. Ready for an up-close look? You can also schedule an in-person visit to get a feel for the community firsthand.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "contactform.form.success_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "footer.contact_us_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "future-residents-club-hero.bg_image": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019efd46-9a02-7298-94ff-b88c4f6470e0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern common area with high ceilings, comfortable seating, and a loft."
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 36,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 37,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_84c768efe7e5e6d383cb5d33",
      "ec_0eed1d1d01e36fad070fe1a0",
      "ec_bc02dce2441e370a55aa8303",
      "ec_b5abe31cb6092596ca853a86",
      "ec_431efdc8fa78ba4681dc9be0",
      "ec_76271b5854f1aee2e6434754",
      "ec_baa7021aff7e16d1c0e45ee9",
      "ec_420957ced1d168599b304893"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      13,
      14,
      15,
      18,
      19,
      22,
      23,
      24
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ]
};

export const styleOverrides = {};
